import { RefreshCw } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";
import { appointment_status } from "@/models/appointment.model";
import { AppointmentApprovalService } from "@/services/appointment-approval.service";
import { fieldActionMessage } from "@/lib/appointment-field-actions";

export class RequestServiceChangeAction extends BaseAppointmentAction {
    readonly config = {
        id: "request_service_change",
        label: "Request Service Change",
        description: "Request service change approval from PMC",
        icon: RefreshCw,
        category: AppointmentActionCategory.REQUEST,
        permissions: {
            requiredRole: [UserRole.SUBS],
            requiredStatuses: [appointment_status.pending, appointment_status.assigned, appointment_status.rescheduled]
        },
        requiresDialog: true,
        variant: "default" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        if (!payload?.newServiceId) {
            return "New service selection is required";
        }
        if (!payload?.newServiceName) {
            return "New service name is required";
        }
        if (!payload?.parentCategory) {
            return "Service category is required";
        }
        return null;
    }

    getDialogComponent(): string {
        return "RequestServiceChangeDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            const { newServiceId, newServiceName, parentCategory } = payload || {};

            if (!newServiceId || !newServiceName || !parentCategory) {
                throw new Error("Service change details are required");
            }

            await AppointmentApprovalService.requestServiceChangeAsAssignee(context.appointmentId, newServiceId);

            return {
                success: true,
                message: "Service change request sent for approval"
            };
        } catch (error: any) {
            return {
                success: false,
                message: fieldActionMessage(error, "Failed to send service change request")
            };
        }
    }
}